import React from "react";
import { Add } from "@mui/icons-material";
import { Fab, Grid, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const addButtonStyle = {
    padding: 11,
    marginRight: 10,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
};

const addButtonWrapper = {
    position: "fixed",
    top: "180px",
    right: "-20px",
    zIndex: "100",
};

function AddButton(props) {
    const { t } = useTranslation();

    return (
        <Grid item xs={2} style={addButtonWrapper} id="ab_Grid">
            <Tooltip title={t("Add")}>
                <Fab id="ab_AddButton" variant="extended" onClick={props.onClick} style={addButtonStyle} color="primary" disabled={props.disabled}>
                    <Add fontSize="large" align="right" id="ab_Add" />
                </Fab>
            </Tooltip>
        </Grid>
    );
}

export default AddButton;
